/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {ServiceDrivenAutoCompleteFieldEditor} from "./ServiceDrivenAutoCompleteFieldEditor";
import {service as OrganizationService} from "../../../Services/OrganizationService";

export const OrganizationFieldEditor = ServiceDrivenAutoCompleteFieldEditor(OrganizationService);
